<template>
  <div @click="checkLimit" ref="container">
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    limit: Number,
  },
  data() {
    return {
      reachLimit: false
    }
  },
  methods: {
    checkLimit() {
      const elms = this.$refs.container.querySelectorAll("input[type=checkbox]");
      const selectedCount = this.$refs.container.querySelectorAll("input[type=checkbox]:checked").length;
      if (selectedCount >= this.limit) {
        this.reachLimit = true;
        for (let i = 0; i < elms.length; i++) {
          if (elms[i].checked) continue;
          elms[i].disabled = true;
        }
      } else if (this.reachLimit) {
        this.reachLimit = false;
        for (let i = 0; i < elms.length; i++) {
          elms[i].disabled = elms[i].fixed;
        }
      }
    },
    unselectAll() {
      const elms = this.$refs.container.querySelectorAll("input[type=checkbox]");
      for (let i = 0; i < elms.length; i++) {
        elms[i].checked = false;
        elms[i].disabled = elms[i].getAttribute("fixed") === "true";
      }
    }
  }
}
</script>